import Link from "@/components/UI/Link/Link";
import Button from "@/components/UI/Button/Button";
import Card from "@/components/UI/Card/Card";
import classNames from "classnames";
import Image from "next/image";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";

interface Section16Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const FindPlanSection = ({ job, page, section, ...props }: Section16Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <Card
          className={classNames(
            "relative flex flex-col gap-24 border-vpBlue-300 bg-vpBlue-200 px-36 pb-0 pt-28 text-center"
          )}
          rounded="large"
        >
          <div className="relative z-10 flex flex-col gap-10 text-center">
            {section?.Title && (
              <h2
                className={classNames("text-5xl font-bold", section?.TitleElement?.ClassName)}
                id={section?.TitleElement?.HtmlId}
                style={section?.TitleElement?.Style}
                {...section?.TitleElement?.Rest}
              >
                {section?.Title}
              </h2>
            )}
            {section?.Subtitle && (
              <div
                className={classNames("text-xl text-vpGray-700", section?.TitleElement?.ClassName)}
                id={section?.SubtitleElement?.HtmlId}
                style={section?.SubtitleElement?.Style}
                {...section?.SubtitleElement?.Rest}
              >
                {section?.Subtitle}
              </div>
            )}
            {section?.Button && (
              <div className="flex justify-center gap-10">
                {section?.Button && (
                  <Link className="block" href={section?.Button?.Url ?? ""} variant="external">
                    <Button className="mx-auto" size="large">
                      {section?.Button?.Value}
                    </Button>
                  </Link>
                )}
                {section?.Button2 && (
                  <Link className="block" href={section?.Button2?.Url ?? ""} variant="external">
                    <Button className="mx-auto" size="large" variant="text">
                      {section?.Button2?.Value}
                    </Button>
                  </Link>
                )}
              </div>
            )}
          </div>
          <div className="relative z-10 flex items-center justify-around border-t border-t-blue-200 py-10">
            {section?.FortuneCompaniesPercent && section?.FortuneCompaniesLabel && (
              <div className="flex items-center gap-2">
                <span className="text-sm font-bold">{section?.FortuneCompaniesPercent}</span>
                <span className="text-sm text-vpGray-700">{section?.FortuneCompaniesLabel}</span>
              </div>
            )}
            {section?.UsersCount && section?.UsersLabel && (
              <div className="flex items-center gap-2">
                <span className="text-sm font-bold">{section?.UsersCount}</span>
                <span className="text-sm text-vpGray-700">{section?.UsersLabel}</span>
              </div>
            )}
          </div>
          <Image
            alt="Clouds background image"
            className="absolute left-0 top-0 z-0 w-full opacity-70"
            height="384"
            src="/_public-pages-service/clouds.svg"
            width="756"
          />
        </Card>
      </SectionContainer>
    </Section>
  );
};

export default FindPlanSection;
